export default "__VITE_ASSET__4oZI3V_P__"